// import "./markup-menu";
import $ from 'jquery';
global.$ = global.jQuery = $;
import { sliders } from './components/sliders';
import "slick-carousel";
import { main } from './components/main';
import Tabs from "./components/tabs";
require("jquery-fancybox/source/js/jquery.fancybox");

document.addEventListener("DOMContentLoaded", () => {
  sliders();
  $(".fancybox").fancybox();
  main();
  new Tabs();
});



// WEBPACK FOOTER //
// app/scripts/index.js